export default "__VITE_ASSET__BpgOzxoC__"